import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import {
  pageCount
} from './helpers';

import PageSizeSelector from './PageSizeSelector';

const styles = theme => ({
  pagination: {
    margin: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    padding: [[theme.spacing.unit * 1.5, theme.spacing.unit * 3]]
  },
  rowsLabel: {
    ...theme.typography.caption,
    paddingRight: theme.spacing.unit * 5
  },
  button: {
    color: theme.typography.color.light,
    minWidth: theme.spacing.unit * 2
  },
  activeButton: {
    color: theme.typography.color.main,
    fontWeight: 'bold',
    cursor: 'default'
  },
  arrowButton: {
    display: 'inline-block',
    transform: theme.direction === 'rtl' ? 'rotate(180deg)' : null,
    msTransform: theme.direction === 'rtl' ? 'rotate(180deg)' : null
  },
  spacer: {
    ['@media (max-width:899px)']: {
      flex: 1
    }
  },
  prev: {
    marginRight: 0,
    ['@media (max-width:899px)']: {
      padding: 0
    }
  },
  next: {
    marginLeft: 0,
    ['@media (max-width:899px)']: {
      padding: 0
    }
  },
  '@media(max-width: 768px)': {
    button: {
      display: 'none'
    },
    prev: {
      marginRight: theme.spacing.unit
    },
    next: {
      marginLeft: theme.spacing.unit
    },
    rowsLabel: {
      paddingRight: theme.spacing.unit * 2
    }
  }
});

const PageButton = ({ text, isActive, isDisabled, classes, onClick }) => {
  const buttonClasses = classNames({
    [classes.button]: true,
    [classes.activeButton]: isActive
  });

  return (
    <Button
      className={buttonClasses}
      disabled={isDisabled}
      onClick={onClick}
      {...(isActive ? { tabIndex: -1 } : null)}
    >
      {text}
    </Button>
  );
};

PageButton.propTypes = {
  text: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  isDisabled: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func
};

PageButton.defaultProps = {
  onClick: () => {},
  isDisabled: false,
  isActive: false
};

const PaginationBase = ({
  pageSize,
  pageSizes,
  currentPage,
  nextPage,
  onCurrentPageChange,
  onPageSizeChange,
  classes
}) => {

  return (
    <div className={classes.pagination}>
      <PageSizeSelector
        pageSize={pageSize}
        onPageSizeChange={onPageSizeChange}
        pageSizes={pageSizes}
      />
      <div className={classes.spacer} />
      <div>
        <IconButton
          className={classNames(classes.arrowButton, classes.prev)}
          disabled={currentPage === 0}
          onClick={() =>
            currentPage > 0 && onCurrentPageChange(currentPage - 1)
          }
          aria-label="Previous"
        >
          <ChevronLeft />
        </IconButton>
        <PageButton
          key="currentPage"
          text={(currentPage + 1).toString()}
          isActive
          classes={classes}
        />
        <IconButton
          className={classNames(classes.arrowButton, classes.next)}
          disabled={!nextPage}
          onClick={() =>
            onCurrentPageChange(currentPage + 1)
          }
          aria-label="Next"
        >
          <ChevronRight />
        </IconButton>
      </div>
    </div>
  );
};

PaginationBase.propTypes = {
  currentPage: PropTypes.number.isRequired,
  onCurrentPageChange: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  pageSize: PropTypes.number.isRequired,
  pageSizes: PropTypes.array.isRequired
};

export const NoCountPagination = withStyles(styles, { name: 'Pagination' })(
  PaginationBase
);

export default NoCountPagination;